import { _ as r } from "../internals/export.js";
import { a as t } from "../internals/array-to-reversed.js";
import { t as e } from "../internals/to-indexed-object.js";
import { a as o } from "../internals/add-to-unscopables.js";
var a = Array;
r({
  target: "Array",
  proto: !0
}, {
  toReversed: function toReversed() {
    return t(e(this), a);
  }
}), o("toReversed");